import { jsx as _jsx } from "react/jsx-runtime";
import { Alert } from '@applyonline/shared';
import { useEffect, useRef } from 'react';
const ScrollableAlert = ({ showAlert, message, type, buttons, style, linkText, linkType, link, }) => {
    const alertRef = useRef(null);
    useEffect(() => {
        if (showAlert && alertRef.current) {
            alertRef.current.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
    }, [showAlert]);
    return showAlert ? (_jsx("div", { ref: alertRef, children: _jsx(Alert, { type: type, message: message, buttons: buttons, style: style, linkText: linkText, link: link, linkType: linkType }) })) : null;
};
export default ScrollableAlert;
